import { HighlightLastWord } from "@/cms/textHelpers";

export default function ContactHero({ fields = {} }) {
  const {
    eyebrow = "Get In Touch",
    headline = "Contact Us",
    subtext = "Have a question, need help with a booking, or want to plan a bespoke golf trip? We'd love to hear from you.",
  } = fields;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 text-center">
      <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-4">
        {eyebrow}
      </p>
      <h1 className="text-white font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight mb-4">
        <HighlightLastWord text={headline} />
      </h1>
      <p className="text-white/60 text-lg max-w-xl mx-auto whitespace-pre-line">{subtext}</p>
    </section>
  );
}
